export default "__VITE_ASSET__5N0ziqa2__ 288w, __VITE_ASSET__iXASr8j2__ 432w, __VITE_ASSET__vewedVhl__ 576w";